import Logger from 'js-logger'
import moment from 'moment'

Logger.useDefaults({
  defaultLevel: process.env.NODE_ENV === 'production' ? Logger.INFO : Logger.DEBUG
})

let consoleHandler = Logger.createDefaultHandler({
  formatter: function(messages, context) {
    messages.unshift(moment().format(`[[${context.name} ${context.level.name}] h:mm:ss []]`))
  }
})

let customHandler = (messages, context) => {
  if (context.level.name === 'ERROR') {
    setTimeout(_ => {
      let err = new Error(messages[0])
      if (window._errs) {
        window._errs.push(err)
      } else {
        throw err
      }
    })
  }
}

Logger.setHandler((messages, context) => {
  consoleHandler(messages, context)
  customHandler(messages, context)
})

export default Logger.get('logger')



// WEBPACK FOOTER //
// ./src/assets/scripts/logger.js